module.exports = "https://cdn.dove.it/_next/static/public/assets/services/agente-dedicato_340x200.4e2b38225a2c942cdb09bf2298a2a8c2.jpg";